export default {
  buttons: {
    go_to_basket: 'Ir para o Carrinho',
  },
};
